module.exports = __webpack_public_path__ + "static/media/directions_bike.46026c1e.svg";